
export class OroBaseResult {

  public Message: string = 'NOT assigned';
  public Success: boolean = false;
}
